export default __webpack_public_path__ + "static/media/MySQL-WindowsTaskScheduler-Action-StartaProgram06.6336906b.png";